<div class="price-list">
  <div class="price-list__items">
    @for (group of priceList; track group) {
      <div class="price-list__group">
        <span class="price-list__group-name">{{ group.name }}</span>
        @if (group.totalPrice > 0) {
          <span class="price-list__group-price">
            {{ group.totalPrice  | currency: undefined: undefined: 0 }}
          </span>
        }
        @for (item of group.items; track item) {
          <span class="price-list__item">{{ item.name }}</span>
        }
      </div>
    }
  </div>
  <div class="price-list__summary list">
    <span class="price-list__summary-name">{{ 'service-configuration.list-price' | translate }}</span>
    <span class="price-list__summary-price">{{ priceSummary.ListPrice  | currency: undefined: undefined: 0 }}</span>
  </div>
  @if (priceSummary.ContractReduction > 0) {
    <div class="price-list__summary discount">
      <span class="price-list__summary-name">{{ 'service-configuration.discount' | translate }}</span>
      <span class="price-list__summary-price">- {{ priceSummary.ContractReduction  | currency: undefined: undefined: 0 }}</span>
    </div>
  }
  @if (priceSummary.PromocodeReduction > 0) {
    <div class="price-list__summary discount">
      <span class="price-list__summary-name">{{ 'service-configuration.promo-code' | translate }}</span>
      <span class="price-list__summary-price">- {{ priceSummary.PromocodeReduction  | currency: undefined: undefined: 0 }}</span>
    </div>
  }
  @if (priceSummary.ContractReduction > 0) {
    <div class="price-list__summary discount-desc">
      <p>{{ 'service-configuration.discount-desc' | translate }}</p>
      @if (priceSummary.PromocodeReduction === 0) {
        <p>{{ 'service-configuration.discount-promo' | translate }}</p>
      }
      @if (priceSummary.PromocodeReduction > 0) {
        <p>{{ 'service-configuration.discount-promo-with-edit' | translate }}</p>
      }
    </div>
  }
  <div class="price-list__summary annual">
    <span class="price-list__summary-name">{{ 'service-configuration.annual-price' | translate }}</span>
    <span class="price-list__summary-price">{{ priceSummary.NetPrice  | currency: undefined: undefined: 0 }}</span>
  </div>
</div>
